import React from 'react';
import SunEditor, { buttonList } from 'suneditor-react';
import './editor.styles.scss';

export function EditorBasic(props: any) {
    const basic2 = [['undo', 'redo'], ['image']];
    return <SunEditor {...props} setOptions={{ buttonList: basic2 }} />;
}

export function EditorComplex(props: any) {
    return (
        <SunEditor {...props} setOptions={{ buttonList: buttonList.complex }} />
    );
}
